import * as types from '../constants/action.types';
import { IAction } from '../constants/action';
import { documentState } from '../constants/initial-state';

export default function documentReducer(state = documentState, action: IAction) {
    switch (action.type) {
        case (types.DOCUMENT_REQUESTED):
            return Object.assign({}, state, { isFetching: true });
        case (types.DOCUMENT_FAILED):
            return Object.assign({}, state, { isFetching: false, error: action.data });
        case (types.DOCUMENT_RETRIEVED):
            state.documents[action.data.id] = action.data.html;
            const documents = Object.assign({}, state.documents);

            return Object.assign({}, state, { isFetching: false, loaded: true, documents });
        default: return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/document.reducer.ts